var map = {
	"./addperson.svg": 3127,
	"./align-center.svg": 3076,
	"./align-justify.svg": 6397,
	"./align-left.svg": 752,
	"./align-right.svg": 9231,
	"./arrow_left.svg": 8946,
	"./arrow_right.svg": 5913,
	"./arrow_up.svg": 3878,
	"./arrowdown.svg": 910,
	"./at.svg": 188,
	"./bedommelsesmodul.svg": 6572,
	"./bell.svg": 3516,
	"./bold.svg": 3462,
	"./calendar.svg": 5033,
	"./camera.svg": 8854,
	"./check.svg": 2497,
	"./check_circle.svg": 6456,
	"./check_white.svg": 2299,
	"./chevron_down.svg": 635,
	"./chevron_left.svg": 1644,
	"./chevron_right.svg": 8947,
	"./chevron_up.svg": 1716,
	"./cityhall.svg": 6827,
	"./clipboard.svg": 5543,
	"./clipboard_2.svg": 2076,
	"./clock.svg": 2075,
	"./clone.svg": 178,
	"./cross.svg": 9973,
	"./cross_circle.svg": 1052,
	"./dash.svg": 5395,
	"./diagram_down.svg": 5729,
	"./diagram_up.svg": 3630,
	"./doc.svg": 1075,
	"./documents.svg": 9243,
	"./dollarcoin.svg": 9530,
	"./dothorizontal.svg": 6228,
	"./dotvertical.svg": 6562,
	"./download.svg": 1303,
	"./drag.svg": 7229,
	"./drag_dynamic.svg": 5915,
	"./empty_doc.svg": 7513,
	"./erhvervs_optagelse.svg": 9373,
	"./eye.svg": 4426,
	"./eyeclosed.svg": 6758,
	"./filter.svg": 7985,
	"./filter_down.svg": 48,
	"./firm.svg": 8967,
	"./flag.svg": 1113,
	"./folder.svg": 811,
	"./font-color.svg": 8606,
	"./font-size-2.svg": 1319,
	"./font-size.svg": 6782,
	"./format-clear.svg": 2522,
	"./gear.svg": 7046,
	"./globe.svg": 5938,
	"./guide.svg": 4941,
	"./heading.svg": 275,
	"./heart.svg": 9733,
	"./hi5_logo.svg": 3583,
	"./hi5_logomark.svg": 6624,
	"./house.svg": 8901,
	"./indent-decrease.svg": 6298,
	"./indent-increase.svg": 5690,
	"./info.svg": 6947,
	"./ingoing_call.svg": 819,
	"./italic.svg": 8083,
	"./key.svg": 7000,
	"./letter.svg": 9019,
	"./link-m.svg": 5005,
	"./link-unlink-m.svg": 3003,
	"./link.svg": 1119,
	"./list-check.svg": 1272,
	"./list-ordered.svg": 4547,
	"./list-unordered.svg": 7532,
	"./location.svg": 4310,
	"./lock-locked.svg": 853,
	"./lock.svg": 5482,
	"./logout.svg": 4277,
	"./mapcluster.svg": 6543,
	"./mapmarker.svg": 45,
	"./megafon.svg": 8906,
	"./moon.svg": 7628,
	"./open_letter.svg": 4038,
	"./outgoing_call.svg": 3680,
	"./paperclip.svg": 9081,
	"./paragraph.svg": 1679,
	"./pencil.svg": 184,
	"./people.svg": 7014,
	"./person.svg": 4388,
	"./person_circle.svg": 4415,
	"./phone.svg": 6345,
	"./plus.svg": 4491,
	"./plus_profil.svg": 6360,
	"./pointerleft.svg": 7321,
	"./printer.svg": 9049,
	"./question.svg": 4515,
	"./question_circle copy.svg": 8625,
	"./question_circle.svg": 2118,
	"./refresh.svg": 2304,
	"./search.svg": 4343,
	"./settings.svg": 716,
	"./sms copy.svg": 8205,
	"./sms.svg": 1794,
	"./star.svg": 815,
	"./strikethrough.svg": 7464,
	"./sun.svg": 7391,
	"./sunrise.svg": 2944,
	"./table-2.svg": 4080,
	"./tag.svg": 8197,
	"./text.svg": 6606,
	"./thumbs_up.svg": 4564,
	"./thumbsdown.svg": 8000,
	"./trash.svg": 6891,
	"./underline.svg": 3081,
	"./updown.svg": 4032,
	"./upload.svg": 600,
	"./warning.svg": 2865,
	"./warning_sign.svg": 7599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;